module.exports = __webpack_public_path__ + "amcharts/images/dragIconRectSmall.svg";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/dragIconRectSmall.svg
// module id = 239
// module chunks = 0